import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import {} from '@mui/material';

import Dashboard from '../../../../layouts/Dashboard';
import EditEmergencyRole from '../../../../components/Global/EmergencyRoles/Edit';

import { editEmergencyRoleInitQuery, EmergencyRole } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  emergency_role_id: string;
}

const EditEmergencyRoleOrg = ({ classes, history }: Props): React.ReactElement => {
  const { emergency_role_id } = useParams<UrlParams>();

  const [emergencyRole, setEmergencyRole] = useState<EmergencyRole>({
    name: '',
  });

  const { data: editEmergencyRoleInitData } = useQuery(editEmergencyRoleInitQuery(emergency_role_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && editEmergencyRoleInitData) {
      setEmergencyRole(editEmergencyRoleInitData.emergency_roles_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [editEmergencyRoleInitData]);

  const handleFinish = () => {
    history.push(`/trust/emergency_roles`);
  };

  return (
    <>
      <Dashboard breadcrumbs={[{ label: 'Emergency roles', link: `/trust/emergency_roles` }, { label: emergencyRole.name }, { label: 'Edit' }]}>
        <EditEmergencyRole emergency_role_id={emergency_role_id} handleFinish={handleFinish} />
      </Dashboard>
    </>
  );
};

export default withRouter(withStyles(styles)(EditEmergencyRoleOrg));
